import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import storage from '../lib/storage';
import { guestService } from '../services';

const AuthContext = createContext(null);

const getInitialSession = () => ({
  isLoggedIn: storage.get('isLoggedIn', 'false') === 'true',
  userName: storage.get('userName', ''),
  userEmail: storage.get('userEmail', ''),
  authToken: storage.get('authToken', ''),
  userPlan: storage.get('userPlan', 'free')
});

export function AuthProvider({ children }) {
  const [session, setSession] = useState(getInitialSession);

  const migrateGuestSession = useCallback(async () => {
    const guestSessionId = storage.get('guest_session_id') || '';
    if (!guestSessionId) {
      return;
    }

    try {
      await guestService.migrate(guestSessionId);
    } catch (error) {
      console.error('Falha ao migrar sessão guest:', error);
    } finally {
      storage.remove('guest_session_id');
      storage.remove('chat_session_id');
    }
  }, []);

  const login = useCallback((payload) => {
    storage.set('isLoggedIn', 'true');
    storage.set('authToken', payload.token || '');
    storage.set('userName', payload.user?.name || '');
    storage.set('userEmail', payload.user?.email || '');
    storage.set('userId', payload.user?.id || '');
    storage.set('userPlan', payload.user?.plan || 'free');

    setSession({
      isLoggedIn: true,
      authToken: payload.token || '',
      userName: payload.user?.name || '',
      userEmail: payload.user?.email || '',
      userPlan: payload.user?.plan || 'free'
    });

    migrateGuestSession();
  }, [migrateGuestSession]);

  const logout = useCallback(() => {
    storage.clear();
    setSession({
      isLoggedIn: false,
      authToken: '',
      userName: '',
      userEmail: '',
      userPlan: 'free'
    });
  }, []);

  const value = useMemo(() => ({ ...session, login, logout }), [login, logout, session]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
